import { classnames } from '@/helpers';

export type ToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  size?: 'default' | 'lg';
};

const TOGGLE_BUTTON_STYLES: {
  [key in NonNullable<ToggleProps['size']>]: React.CSSProperties;
} = {
  default: { width: 29, height: 40 },
  lg: { width: 40, height: 40 },
};
const TOGGLE_SLIDER_STYLES: {
  [key in NonNullable<ToggleProps['size']>]: React.CSSProperties;
} = {
  default: { width: 29, height: 18 },
  lg: { width: 40, height: 24 },
};

const TOGGLE_STYLES: {
  [key in NonNullable<ToggleProps['size']>]: React.CSSProperties;
} = {
  default: { width: 12, height: 12 },
  lg: { width: 16, height: 16 },
};

const Toggle = ({ checked, onChange, size = 'default', disabled = false, className }: ToggleProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onChange(!checked);
  };

  const handleMouseDown = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      className={classnames('grid place-content-center')}
      style={TOGGLE_BUTTON_STYLES[size]}>
      <span
        className={classnames(
          'relative inline-flex items-center rounded-full outline-none transition-colors duration-200 ease-in-out',
          'focus-visible:ring-bg_brand focus-visible:ring-2 focus-visible:ring-offset-1',

          // checked styles
          checked && !disabled ? 'bg-brand' : '',
          checked && disabled ? 'bg-brand' : '',
          // unchecked styles
          !checked && !disabled ? 'bg-bg_secondary border-border_bold border' : '',
          !checked && disabled ? 'bg-bg_secondary border-border_regular border' : '',
        )}
        style={TOGGLE_SLIDER_STYLES[size]}>
        <span
          className={classnames(
            'absolute inline-block rounded-full shadow-sm transition-transform duration-200 ease-in-out',
            checked
              ? size === 'lg'
                ? 'translate-x-[20px]'
                : 'translate-x-[14px]'
              : size === 'lg'
              ? 'translate-x-[4px]'
              : 'translate-x-[2px]',
            // checked styles
            checked && !disabled && 'border-fg_alwaysLight bg-fg_alwaysLight border',
            checked && disabled && 'border-fg_alwaysLight bg-brand border opacity-20',
            // unchecked styles
            !checked && !disabled && 'bg-fg_alwaysLight',
            !checked && disabled && 'border-border_regular bg-bg_secondary border',
            !disabled && '',
          )}
          style={TOGGLE_STYLES[size]}
        />
      </span>
    </button>
  );
};

export default Toggle;
